import { render, staticRenderFns } from "./UserPortal.vue?vue&type=template&id=6cc140f8&"
import script from "./UserPortal.vue?vue&type=script&lang=js&"
export * from "./UserPortal.vue?vue&type=script&lang=js&"
import style0 from "./UserPortal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports